import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=0e7376be&scoped=true"
import script from "./QRCode.vue?vue&type=script&lang=js"
export * from "./QRCode.vue?vue&type=script&lang=js"
import style0 from "./QRCode.vue?vue&type=style&index=0&id=0e7376be&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7376be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e7376be')) {
      api.createRecord('0e7376be', component.options)
    } else {
      api.reload('0e7376be', component.options)
    }
    module.hot.accept("./QRCode.vue?vue&type=template&id=0e7376be&scoped=true", function () {
      api.rerender('0e7376be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QRCode.vue"
export default component.exports